"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var window_wrapper_1 = require("@reverbdotcom/commons/dist/window_wrapper");
function windowNavigator() {
    if (!(window_wrapper_1.default && window_wrapper_1.default.navigator)) {
        return {
            userAgent: '',
            language: '',
            javaEnabled: function () { return false; },
        };
    }
    return window_wrapper_1.default.navigator;
}
function windowScreen() {
    if (!(window_wrapper_1.default && window_wrapper_1.default.screen)) {
        return {
            colorDepth: null,
            width: null,
            height: null,
        };
    }
    return window_wrapper_1.default.screen;
}
function browserInfo() {
    var navigator = windowNavigator();
    var screen = windowScreen();
    return {
        screen_width: screen.width,
        screen_height: screen.height,
        color_depth: screen.colorDepth,
        user_agent: navigator.userAgent,
        language: navigator.language,
        java_enabled: navigator.javaEnabled(),
        time_zone_offset: new Date().getTimezoneOffset(),
    };
}
exports.browserInfo = browserInfo;
//# sourceMappingURL=browser_info.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/browser_info.js
// module id = t4Wh
// module chunks = 20 21